import EventEmitter from "./utils/EventEmitter";

export default class TableOfContent extends EventEmitter {
    constructor(element) {
        super();

        this.el = element
        this.tableContentWrapper = this.el.querySelector('.table-of-content-list-wrapper')
        this.btn = this.el.querySelector('.t-btn--action')

        // get anchors in content
        this.anchorTargets = document.querySelectorAll('.analyse-anchor')

        if (this.anchorTargets.length === 0) {
            this.el.style.display = 'none'
            return
        }

        this.createList()
        this.events()
    }

    events() {
        this.btn.addEventListener('click', () => {
            this.el.classList.toggle('is-open')
        })
    }

    createList() {
        this.anchorTargets.forEach((anchor) => {
            const anchorId = anchor.getAttribute('id')
            const anchorTitle = anchor.getAttribute('data-text')

            const div = document.createElement('div')

            const a = document.createElement('a')
            a.setAttribute('href', '#' + anchorId)
            a.innerHTML = anchorTitle

            a.addEventListener('click', () => {
                this.el.classList.remove('is-open')
            })

            div.appendChild(a)
            this.tableContentWrapper.appendChild(div)
        })
    }

}
